import { useSelector } from 'react-redux';
import { lazy } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

// import Login from '../pages/login/login3';
import Loadable from 'ui-component/Loadable';
import useToken from './useToken';
import usePermissions from './usePermissions';
// import useDeviceId from './hooks/useDeviceId';
// import useLocation from './hooks/useLocation';
import { useLocation, useNavigate } from 'react-router-dom';

const Login = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const Register = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword')));
const ChangePassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ChangePassword')));
const ConfirmRegistration = Loadable(lazy(() => import('views/pages/authentication/authentication3/ConfirmRegistration')));

// function strcmp(aa, bb) {
//     if (!aa) return -1;
//     if (!bb) return 1;
//     const a = aa.toString();
//     const b = bb.toString();
//     // a = a.toString(), b = b.toString();
//     let i;
//     const n = Math.max(a.length, b.length);
//     for (i = 0; i < n && a.charAt(i) === b.charAt(i); i += 1);
//     if (i === n) return 0;
//     return a.charAt(i) > b.charAt(i) ? -1 : 1;
// }

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    // const [token, setToken] = useState();
    // const token = getToken();
    const { token, setToken } = useToken();
    const { permissions, setPermissions } = usePermissions();
    // const [userName, setUserName] = useState('');
    // console.log('App() token', token);
    // const { deviceId } = useDeviceId();
    // const { locationData } = useLocation();
    // // console.log('deviceId', deviceId, 'locationData', locationData, 'ip', locationData.IPv4);
    // console.log('deviceId', deviceId, 'locationData', locationData);

    const location = useLocation();
    // console.log(location.pathname);
    const navigate = useNavigate();
    console.log('App() render, token:', token, 'permissions:', permissions);

    let pageContent = '';
    if (!token) {
        if (location.pathname === '/register') {
            pageContent = (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themes(customization)}>
                        <Register setToken={setToken} />
                    </ThemeProvider>
                </StyledEngineProvider>
            );
        } else if (location.pathname === '/forgot-password') {
            pageContent = (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themes(customization)}>
                        <ForgotPassword setToken={setToken} />
                    </ThemeProvider>
                </StyledEngineProvider>
            );
        } else if (location.pathname === '/change-password') {
            pageContent = (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themes(customization)}>
                        <ChangePassword setToken={setToken} />
                    </ThemeProvider>
                </StyledEngineProvider>
            );
        } else if (location.pathname === '/confirm-registration') {
            pageContent = (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themes(customization)}>
                        <ConfirmRegistration setToken={setToken} />
                    </ThemeProvider>
                </StyledEngineProvider>
            );
        } else {
            pageContent = (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themes(customization)}>
                        <Login setToken={setToken} setPermissions={setPermissions} />
                    </ThemeProvider>
                </StyledEngineProvider>
            );
        }
    } else if (location.pathname === '/confirm-registration') {
        navigate(`/`);
    }
    // else {
    //     // console.log('App() permissions:', permissions);
    //     // console.log('App() location.pathname.indexOf(private):', location.pathname.indexOf('private'));
    //     if (strcmp(permissions, '0') === 0) {
    //         // alert('about to navigate');
    //         if (location.pathname.indexOf('private') === -1) navigate(`/private`);
    //     }
    // }
    if (pageContent) return pageContent;

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
